export default __webpack_public_path__ + "static/media/icon-cancel.f334f6bf.svg";